module.exports = __webpack_public_path__ + "static/media/myphoto3.c30b33ef.JPG";